import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INivelesPromo } from './../../../../private/shared/models/productos';

interface ILevelStepBadge extends INivelesPromo {
  Cumple?: boolean;
}

@Component({
  selector: 'getm-level-step-badge',
  templateUrl: './level-step-badge.component.html',
  styleUrls: ['./level-step-badge.component.scss'],
})
export class LevelStepBadgeComponent implements OnInit {

  @Input() Niveles: ILevelStepBadge[] = [];
  @Input() level = 0;
  @Input() isEditing = false;
  @Input() isEditingLocked = false;

  @Output() levelClick = new EventEmitter<number>();

  constructor() { }

  ngOnInit() { }

  public onLevelClick = (nivel: number) => this.levelClick.emit(nivel);

  public trackByLevel = (index: number, item: ILevelStepBadge) => item.Nivel;

  public shouldShowBadge(nivel: ILevelStepBadge): boolean {
    if (this.isEditing) return true;
    const isLastLevel = nivel.Nivel === this.Niveles.length;
    return nivel.Cumple === true && (this.level !== nivel.Nivel || isLastLevel);
  }
}
